import {
    CompactType,
    DisplayGrid,
    Draggable,
    GridsterConfig,
    GridType, PushDirections,
    Resizable,
} from 'angular-gridster2';

export interface Safe extends GridsterConfig {
    draggable: Draggable;
    resizable: Resizable;
    pushDirections: PushDirections;
}

export interface DashboardGridsterItem {
    x: number;
    y: number;
    rows: number;
    cols: number;
    name?: string;
    hasEdit?: boolean;
    hasOpen?: boolean;
    hasAdd?: boolean;
    headerTitle?: string;
    minItemRows?: number;
    maxItemRows?: number;
    minItemCols?: number;
    maxItemCols?: number;
    init?: boolean;
    dragEnabled?: boolean;
    resizableHandles?: {
        s?: boolean;
        e?: boolean;
        n?: boolean;
        w?: boolean;
        se?: boolean;
        ne?: boolean;
        sw?: boolean;
        nw?: boolean;
    };
}

export const DASHBOARD_ITEM_HEIGHT = 48;
export const DASHBOARD_WIDTH_STEP = 5;
export const DASHBOARD_GRID_MARGIN = 8;
export const DASHBOARD_OUTER_MARGIN = 8;

export const SCALING_FACTOR = 2;

export const basicGridsterItem: DashboardGridsterItem = {
    cols: 5 * SCALING_FACTOR,
    rows: 3 * SCALING_FACTOR,
    x: 0,
    y: 0,
    minItemRows: 3,
};

export const tightBasicGridsterItem: DashboardGridsterItem = {
    cols: 4 * SCALING_FACTOR,
    rows: 3 * SCALING_FACTOR,
    x: 0,
    y: 0,
    minItemRows: 3,
};

export const smallBasicGridsterItem: DashboardGridsterItem = {
    cols: 3 * SCALING_FACTOR,
    rows: 3 * SCALING_FACTOR,
    x: 0,
    y: 0,
    minItemRows: 3,
};

export const gridsterOptions = {
    gridType: GridType.ScrollVertical,
    compactType: CompactType.None,
    margin: DASHBOARD_GRID_MARGIN,
    outerMargin: true,
    fixedRowHeight: DASHBOARD_ITEM_HEIGHT,
    defaultItemCols: 5,
    defaultItemRows: 5,
    minCols: (100 / DASHBOARD_WIDTH_STEP) * SCALING_FACTOR,
    maxCols: (100 / DASHBOARD_WIDTH_STEP) * SCALING_FACTOR,
    minRows: 1,
    minItemCols: 2,
    maxItemCols: (100 / DASHBOARD_WIDTH_STEP) * SCALING_FACTOR,
    minItemRows: 1,
    maxItemRows: 100,
    ignoreMarginInRow: false,
    draggable: {
        enabled: true,
        ignoreContent: true,
    },
    resizable: {
        enabled: true,
    },
    swap: false,
    pushItems: true,
    disablePushOnDrag: false,
    disablePushOnResize: false,
    pushDirections: { north: true, east: true, south: true, west: true },
    pushResizeItems: false,
    displayGrid: DisplayGrid.OnDragAndResize,
    disableWindowResize: false,
    disableScrollHorizontal: true,
    disableWarnings: false,
    scrollToNewItems: false,
    addEmptyRowsCount: 1,
};
